import type { QueryClient } from '@tanstack/react-query';
import type { LoaderFunctionArgs, RouteObject } from 'react-router';
import { aiAdminQuery } from '../../api/ai';
import { teamsTestStatusQuery } from '../../api/teams';
import type { RouteHandle } from '../../app/RootLayout';
import { forRoles } from '../../search/pages';
import { adminLoad } from '../routes';

const handle: RouteHandle = {
  help: { pageLabel: 'Settings · System administration · AI', topicIds: [], pageKey: 'admin-ai' },
  search: {
    label: 'AI settings',
    meta: 'Settings › System administration › AI · provider, key, model and which AI features are on',
    visible: forRoles('system_admin'),
  },
};

const teamsTestHandle: RouteHandle = {
  help: {
    pageLabel: 'Settings · System administration · Teams test chat',
    topicIds: [],
    pageKey: 'admin-ai',
  },
};

/**
 * Settings › System administration › AI (SYS7), for System Admins; for anyone else the page doesn't exist. It sits in the
 * Admin frame with the other tabs; the page's code loads on first use.
 */
export function aiAdminRoutes(queryClient: QueryClient): RouteObject[] {
  return [
    {
      path: 'settings/system/ai',
      loader: ({ request }: LoaderFunctionArgs) =>
        adminLoad(queryClient, request, () => queryClient.query(aiAdminQuery)),
      lazy: async () => ({ Component: (await import('./AiAdminPage')).AiAdminPage }),
      handle,
    },
    {
      // APP-089: playing the Teams app as someone, on a local build only (the page says so
      // elsewhere). Not in search: it's a testing tool, reached from the Teams app's row.
      path: 'settings/system/ai/teams-test',
      loader: ({ request }: LoaderFunctionArgs) =>
        adminLoad(queryClient, request, () => queryClient.query(teamsTestStatusQuery)),
      lazy: async () => ({
        Component: (await import('./TeamsTestChatPage')).TeamsTestChatPage,
      }),
      handle: teamsTestHandle,
    },
  ];
}
